import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportEditionMetricDialogComponent } from '../report-edition-metric-dialog/report-edition-metric-dialog.component';
import { ReportEditionVerbatimDialogComponent } from '../report-edition-verbatim-dialog/report-edition-verbatim-dialog.component';

/**
 * This component goal is to be able to open an angular dialog from AJS.
 * It will be opened from the AJS $mdDialog and will open a NG dialog
 * (so there will be 2 dialogs opened, the transparent background will be darker)
 */
@Component({
  selector: 'app-metrics-dialog-container-for-ajs',
  template: '',
})
export class MetricsDialogContainerForAjsComponent implements OnInit {
  @Input() data: any;
  @Output() cancelDialog = new EventEmitter();
  @Output() hideDialog = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    const registry = {
      ['ReportEditionMetricDialogComponent']: ReportEditionMetricDialogComponent,
      ['ReportEditionVerbatimDialogComponent']: ReportEditionVerbatimDialogComponent,
    };
    const dialogRef = this.dialog.open(registry[this.data['componentName']], {
      disableClose: true,
      panelClass: ['large-size'],
      data: this.data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.hideDialog.emit(result);
      } else {
        this.cancelDialog.emit();
      }
    });
  }
}
